const DailyRoutinesSvg = () => (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6252 24.4417C8.85604 24.4417 4.17187 19.7575 4.17187 13.9883C4.17187 10.4545 5.93004 7.32784 8.61687 5.43551C9.01237 5.15667 9.10687 4.61067 8.82921 4.21634C8.55154 3.82084 8.00437 3.72634 7.61004 4.00401C4.47288 6.21367 2.42188 9.86301 2.42188 13.9883C2.42188 20.7235 7.89004 26.1917 14.6252 26.1917C15.1082 26.1917 15.5002 25.7997 15.5002 25.3167C15.5002 24.8337 15.1082 24.4417 14.6252 24.4417Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3001 3.55587C20.7554 3.90354 25.0791 8.44537 25.0791 13.9882C25.0791 17.1744 23.6511 20.028 21.4006 21.946C21.0331 22.2599 20.9887 22.8129 21.3026 23.1804C21.6152 23.5479 22.1682 23.5922 22.5357 23.2784C25.1631 21.0395 26.8291 17.7064 26.8291 13.9882C26.8291 7.51671 21.7809 2.21537 15.4109 1.80937C14.9291 1.77904 14.5126 2.14537 14.4822 2.62721C14.4519 3.10904 14.8182 3.52554 15.3001 3.55587Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.7144 22.3823H21.6797V20.3477C21.6797 19.8647 21.2877 19.4727 20.8047 19.4727C20.3217 19.4727 19.9297 19.8647 19.9297 20.3477V23.2573C19.9297 23.7403 20.3217 24.1323 20.8047 24.1323H23.7144C24.1974 24.1323 24.5894 23.7403 24.5894 23.2573C24.5894 22.7743 24.1974 22.3823 23.7144 22.3823Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.21484 4.56494H8.24834V6.59844C8.24834 7.08144 8.64034 7.47344 9.12334 7.47344C9.60634 7.47344 9.99834 7.08144 9.99834 6.59844V3.68994C9.99834 3.20694 9.60751 2.81494 9.12334 2.81494H6.21484C5.73184 2.81494 5.33984 3.20694 5.33984 3.68994C5.33984 4.17294 5.73184 4.56494 6.21484 4.56494Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9622 7.28467C11.2592 7.28467 8.25391 10.2912 8.25391 13.993C8.25391 17.696 11.2592 20.7013 14.9622 20.7013C18.6641 20.7013 21.6706 17.696 21.6706 13.993C21.6706 10.2912 18.6641 7.28467 14.9622 7.28467ZM13.7956 10.7847V13.7013C13.7956 13.9335 13.8877 14.1563 14.0522 14.3208L16.3856 16.6542C16.7262 16.9948 17.2816 16.9948 17.6222 16.6542C17.9641 16.3123 17.9641 15.7582 17.6222 15.4163L15.5456 13.3397V10.7847C15.5456 10.3017 15.1536 9.90967 14.6706 9.90967C14.1876 9.90967 13.7956 10.3017 13.7956 10.7847Z"
      fill="currentColor"
    />
  </svg>
);

export default DailyRoutinesSvg;
